import assign from 'object-assign';
import Axios from 'core/axios';
import Rest from 'core/rest';
import { getLocale } from 'core/i18n';
import Tools from 'core/tools';

export const MAIN_OPEN_MASK = 'MAIN_OPEN_MASK';
export const MAIN_CLOSE_MASK = 'MAIN_CLOSE_MASK';
export const MAIN_OPEN_ERROR = 'MAIN_OPEN_ERROR';
export const MAIN_CLOSE_ERROR = 'MAIN_CLOSE_ERROR';

export const MAIN_POST_SESSION_SUCCESS = 'MAIN_POST_SESSION_SUCCESS';
export const MAIN_DELETE_SESSION_SUCCESS = 'MAIN_DELETE_SESSION_SUCCESS';
export const MAIN_GET_ACCOUNT_BALANCE_SUCCESS = 'MAIN_GET_ACCOUNT_BALANCE_SUCCESS';
export const MAIN_CHANGE_LANUAGE = 'MAIN_CHANGE_LANUAGE';
export const MAIN_GET_TRANSLATION_SUCCESS = 'MAIN_GET_TRANSLATION_SUCCESS';
export const MAIN_GET_APP_SETTINGS_SUCCESS = 'MAIN_GET_APP_SETTINGS_SUCCESS';
export const MAIN_POST_ROLE_SUCCESS = 'MAIN_POST_ROLE_SUCCESS';
export const MAIN_GET_ALL_AGENT = 'MAIN_GET_ALL_AGENT';

export function openMask() {
	return (dispatch) => {
		dispatch({
			type: MAIN_OPEN_MASK
		});
	};
}

export function closeMask() {
	return (dispatch) => {
		dispatch({
			type: MAIN_CLOSE_MASK
		});
	};
}

export function openError(error, type, header) {
	return (dispatch) => {
		dispatch({
			type: MAIN_OPEN_ERROR,
			errorResponse: error.response,
			errorType: type,
			errorHeader: header
		});
	};
};

export function closeError() {
	return (dispatch) => {
		dispatch({
			type: MAIN_CLOSE_ERROR
		});
		return Promise.resolve();
	};
}

export function postSession(data, props) {
	return (dispatch) => {
		dispatch(openMask());
		return Axios.post(Rest.session.postSession(), data)
			.then(async(response) => {
				await dispatch(closeMask());

				// 登入成功後，將token & agentName 存入sessionStorage
				sessionStorage.setItem('user', JSON.stringify(response.data));
				sessionStorage.setItem('agentName', data.agentName);
			
				// 取得帳戶餘額
				await dispatch(getAccountBalance());
				// 導轉至首頁
				let url = Tools.generateLocaleUrl(getLocale(), '/Home')
				if (props && props.history) props.history.push(url);

				return dispatch({
					type: MAIN_POST_SESSION_SUCCESS,
					agentName: data.agentName
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
}

export function deleteSession(props) {
	return (dispatch) => {
		dispatch(openMask());
		return Axios.delete(Rest.session.deleteSession())
			.then(() => {
				dispatch(closeMask());
				// 登出成功後，移除sessionStorage中token & agentName
				sessionStorage.removeItem('user');
				sessionStorage.removeItem('agentName');
				// 導轉至首頁
				let url = Tools.generateLocaleUrl(getLocale(), '/Login')
				if (props && props.history) props.history.push(url);

				return dispatch({
					type: MAIN_DELETE_SESSION_SUCCESS
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
}

export function getAccountBalance() {
	return (dispatch) => {
		dispatch(openMask());
		return Axios.get(Rest.organization.getAccountBalance())
			.then((response) => {
				const { data = {} } = response;
				dispatch(closeMask());
				return dispatch({
					type: MAIN_GET_ACCOUNT_BALANCE_SUCCESS,
					data
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
}

export function changeLanuage(lang, props) {
	return (dispatch) => {
		// 切換語系替換目前網址
		let currentPage = props.location.pathname.split('/')[2];
		let url = Tools.generateLocaleUrl(getLocale(), `/${currentPage ? currentPage : 'Login'}`)

		if (props && props.location.search) 
			//如果有query string則補入
			url += props.location.search
		if (props && props.history)
			props.history.replace(url);

		return dispatch({
			type: MAIN_CHANGE_LANUAGE,
			data: lang
		});
	};
}

export function getTranslation() {
	return async (dispatch) => {
		dispatch(openMask());
		let langArray = ['zh-TW', 'ja-JP', 'ko-KR', 'th-TH', 'en-US'];
		let reponseObject = {};
		for (let i = 0; i < langArray.length; i++) {
			await fetch(Rest.static.getTranslation(langArray[i]))
				.then((response) => {
					return response.json();
				}).then((jsonData) => {
					switch (i) {
						case 0:
							assign(reponseObject, { 'zh-tw': jsonData });
							break;
						case 1:
							assign(reponseObject, { 'jp': jsonData });
							break;
						case 2:
							assign(reponseObject, { 'kr': jsonData });
							break;
						case 3:
							assign(reponseObject, { 'th': jsonData });
							break;
						case 4:
							assign(reponseObject, { 'en': jsonData });
							break;
						default:
							break;
					}
				}).catch((error) => {
					dispatch(closeMask());
					return dispatch(openError(error));
				});
		}
		dispatch(closeMask());
		return dispatch({
			type: MAIN_GET_TRANSLATION_SUCCESS,
			data: reponseObject
		});
	};
};

export function getB2BAppSettings() {
	return (dispatch) => {
		dispatch(openMask());
		return fetch(Rest.static.getB2BAppSettings())
				.then((response) => {
					return response.json();
				}).then((jsonData) => {
					dispatch(closeMask());
					return dispatch({
						type: MAIN_GET_APP_SETTINGS_SUCCESS,
						data: jsonData
					});
				}).catch((error) => {
					dispatch(closeMask());
					return dispatch(openError(error));
				});
		
	};
};

export function postRole() {
	return (dispatch) => {
		dispatch(openMask());
		return Axios.post(Rest.agent.postRole())
			.then((response) => {
				const { data = {} } = response;
				dispatch(closeMask());
				return dispatch({
					type: MAIN_POST_ROLE_SUCCESS,
					data
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
}

export function getAllAgent() {
	return (dispatch) => {
		dispatch(openMask());
		return Axios.get(Rest.agent.getAllAgent())
			.then((response) => {
				dispatch(closeMask());
				return dispatch({
					type: MAIN_GET_ALL_AGENT,
					data: response.data
				});
			})
			.catch((error) => {
				dispatch(closeMask());
				return dispatch(openError(error));
			});
	};
}